import { Link } from "react-router-dom";
import AddCircleIcon from "@mui/icons-material/AddCircle";
import { useEffect, useState } from "react";
import { getRequest, ResponseDataType } from "api";
import { toast } from "react-toastify";

export interface OrganizationInfo {
  id: string;
  name: string;
  logo: string;
  numberOfMembers: number;
  memberAvatar: string;
  memberId: string;
  memberDepartmentCode: string;
}
interface OrgListDto {
  orgId?: string;
  orgList: OrganizationInfo[];
  memberId?: string;
}

interface MemberDepartmentInfo {
  name: string;

  namecode: string;

  isManager: boolean;
}

interface MemberInfoInList {
  id: string;

  name: string;

  avatar: string;

  departmentInfo?: MemberDepartmentInfo;
}

interface GetOrgMemberListResDto {
  managerList: string[];

  memberList: MemberInfoInList[];
}

export const CreateStreamButton = () => {
  const [memberId, setMemberId] = useState<string | null>(null);
  const [memberList, setMemberList] = useState<MemberInfoInList[]>([]);

  useEffect(() => {
    const fetchData = async () => {
      const orgRes: ResponseDataType<OrgListDto> = await getRequest(
        `/customer/get-org-list?customerId=${localStorage.getItem(
          "customerId"
        )}${
          localStorage.getItem("organizationId")
            ? `&orgId=${localStorage.getItem("organizationId")}`
            : ""
        }`
      );
      setMemberId(orgRes.data?.memberId || null);

      const groupRes: ResponseDataType<GetOrgMemberListResDto> =
        await getRequest(
          `/organization/get-org-member-list-by-group?orgId=${localStorage.getItem(
            "organizationId"
          )}`
        );
      setMemberList(groupRes.data?.memberList || []);
    };

    fetchData();
  }, []);

  const handleClick = (e: React.MouseEvent<HTMLAnchorElement, MouseEvent>) => {

    const isMember = memberList.some((member) => member.id === memberId);
    const member = memberList.map((member) => member.id);
    console.log(member);

    if (!isMember) {
      e.preventDefault(); // chặn Link điều hướng
      toast.error("Không thể thêm task vì chưa được thêm vào group!");
    }
  };

  return (
    <>
      <Link
        to="/create-stream"
        style={{
          borderRadius: "50%",
          position: "fixed",
          left: "20px",
          bottom: "20px",
        }}
        onClick={handleClick}
      >
        <AddCircleIcon
          sx={{
            fontSize: "70px",
            cursor: "pointer",
            color: "black",

            "@media (max-width: 480px)": {
              fontSize: "50px",
            },
          }}
        />
      </Link>
    </>
  );
};
